/* eslint-disable no-param-reassign */
import Q from 'q';
import { createAsyncThunk } from '@reduxjs/toolkit';

const PAGE_SIZE = 5000;

export const getProducts = createAsyncThunk(
  'products/getProducts',
  async (_, {
    extra: { Logger, Toast, sdk },
  }) => {
    try {
      const result = [];
      let isFull = false;
      do {
        // eslint-disable-next-line no-await-in-loop
        const { data } = await sdk.products.getProducts({ from: result.length, size: PAGE_SIZE });
        if (!data || !data.length || data.length < PAGE_SIZE) {
          isFull = true;
        }
        result.push(...data);

        // Wait for a while to avoid too many requests in a short time
        // eslint-disable-next-line no-await-in-loop
        await Q.delay(300);
      } while (!isFull);

      return result;
    } catch (error) {
      Logger.log('UI', 'ToastProductsNotLoaded');
      Toast(
        'Products not loaded. Refresh and try again',
        { autoClose: false, type: 'error' },
      );
      Logger.error(new Error('Error products fetching'), { error }, [
        'FetchProductsFailed',
        { errorMessage: 'Products can not be fetched from backend.' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    getProducts.pending,
    (state) => {
      state.isLoaded = false;
      state.isLoading = true;
      state.error = null;
    },
  ).addCase(
    getProducts.fulfilled,
    (state, { payload }) => {
      state.isLoaded = true;
      state.isLoading = false;
      state.error = null;
      state.items = payload;
    },
  ).addCase(
    getProducts.rejected,
    (state, { error }) => {
      state.items = [];
      state.isLoaded = false;
      state.isLoading = false;
      state.error = error;
    },
  );
};
